/**
 * @flow
 * @format
 */

import React from 'react';
import _ from 'lodash';
import { Col } from 'reactstrap';
import { connect } from 'react-redux';

// import cc from 'classcat';
import { deepDiffer } from '~/utils';

import type { Connector } from 'react-redux';
import type { ChartDataType } from '~/modules/design/types';

import ChartLineGraph from '../ChartLineGraph';

// import classes from './GraphGroup.scss';

const area = [
  {
    name: 'CCM',
    inside: true,
    style: { fill: 'lightyellow' },
  },
  {
    name: 'DCM',
    inside: false,
    style: { fill: 'aquamarine' },
  },
];

type ChartType = {
  chartData: ChartDataType,
  chartInfo: {
    x: string,
    y: string,
  },
  chartMarker: {
    'max load': number,
  },
};

type OwnPropsType = {
  id: string,
  chartName: string,
};

type ReduxPropsType = {
  data: ChartType,
};

type PropsType = OwnPropsType & ReduxPropsType;

export class GraphGroup extends React.Component<PropsType> {
  static defaultProps = {
    chartName: 'Untitled Graph',
    data: {
      chartData: {
        Unit: [],
        'Critical Load': [],
      },
      chartInfo: {},
      chartMarker: {},
    },
  };

  shouldComponentUpdate(nextProps: PropsType) {
    return deepDiffer(this.props, nextProps);
  }

  props: PropsType;

  render() {
    // Handle null data condition
    if (!this.props.data) return null;

    const { data: { chartInfo, chartMarker }, chartName } = this.props;
    let { data: { chartData } } = this.props;

    // trim any negaive indexes
    const critLoad = chartData['critical load'] || [];
    const negativeIndex = critLoad.findIndex(i => i < 0);
    if (negativeIndex) {
      chartData = _.mapValues(chartData, (a: number[]) =>
        a.slice(0, negativeIndex),
      );
    }

    const info = {
      y1: 'Current (A)',
      'y1.legend': chartInfo.y,
      x: chartInfo.x,
    };

    const data: ChartDataType = _.mapKeys(chartData, (v, k) => _.startCase(k));
    data['Max Load'] = Array(data.Unit.length).fill(chartMarker['max load']);
    let marker = _.pickBy(chartMarker, v => v !== 0);
    marker = _.omit(marker, 'max load');
    return (
      <Col>
        <ChartLineGraph
          className="svg-content"
          aspectRatio="xMaxYMax"
          chartData={data}
          chartInfo={info}
          chartMarker={marker}
          height={null}
          width={null}
          chartArea={area}
          viewBox={{ x: 0, y: 0, width: 550, height: 325 }}
          resize
          legend="horizontal"
        />
        <h4 className="text-center">
          <strong>{chartName}</strong>
        </h4>
      </Col>
    );
  }
}

function mapStateToProps(
  state: AppStateType,
  ownProps: OwnPropsType,
): PropsType {
  return {
    ...ownProps,
    data: state.global.critChart,
  };
}

const connector: Connector<OwnPropsType, PropsType> = connect(mapStateToProps);

export default connector(GraphGroup);



// WEBPACK FOOTER //
// ./src/components/GraphGroup/GraphGroup.js